import React, { useState, useEffect } from "react";
import { TreeView, toggleIsExpanded } from "baseui/tree-view";
import * as AppConstants from "../../constants/AppConstants";
import * as AppEnums from "../../constants/AppEnums";

export default function TreeSidebar(props) {
  const { treeData } = props;
  const [data, setData] = useState(treeData);

  useEffect(() => {
    setData(data);
  }, [treeData]);

  const getId = (node) => node.id;
  return (
    <TreeView
    overrides={{
      TreeItem: {
        style: ({ $theme }) => ({
          overflow: "hidden",
        }),
      },  
    }}
      data={data}
      getId={getId}
      onToggle={(node) => {
        if (!node.isEditing) {
          // setData((prevData) => toggleIsExpanded(prevData, node, getId));
          if (props.onToggle) props.onToggle(node);
          if (
            (node.children && node.children.length !== 0) ||
            node.type === AppEnums.TREE_ITEM_TYPES.GROUP
          ) {
            if (typeof props.onParentNodeClicked === "function")
              props.onParentNodeClicked(node);
          } else {
            if (typeof props.onLeafNodeClicked === "function")
              props.onLeafNodeClicked(node);
          }
        }
      }}
    />
  );
}
